import { render, staticRenderFns } from "./NotesDetailsIcon.vue?vue&type=template&id=a8c4bbe8&"
import script from "./NotesDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./NotesDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports